import { useEffect, useState } from "react";
import { FileDetails } from "@/types/types";

import ShippingProductView from "./components/ShippingProductView";
import isActionRequired from "./components/IsActionRequired";
import ProductPurchaseView from "./components/ProductPurchaseView";
import CreatorWaitingView from "./components/CreatorWaitingView";
import ShippedProductView from "./components/ShippedProductView";
import PendingShipment from "./components/PendingShipment";
import { ProductShippingProps, ShippingStatus } from "./type/types";
import { useProductShipping } from "./hooks/useProductShipping";
import { TProductShipping } from "@/redux/feature/orderManagement/productShipping/productShippingTypes";
import NestedAccordion from "@/pages/orderMananagement/components/NestedAccordion copy";
import Modal from "@/components/ui/Modal";
import LocationConfirmIcon from "@/assets/icons/locationConfrim.svg";
import { useGlobalContext } from "@/context/GlobalContext";
import {
  useGetShippingAddressesQuery,
  useUploadShippingAddressesMutation,
} from "@/redux/feature/shippingAddress/shippingAddressApi";
import { Info, Plus } from "lucide-react";
import { CustomButton } from "@/components/ui/Buttons";
import HookFormInputField from "@/components/form/HookFormInputField";
import SelectItemWithHookForm from "@/components/form/HookForm/SelectItemWithHookForm";
import { FormProvider, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { handleApiRequest } from "@/utils/handleApiRequest";
import { normalizeGoogleMapsLink } from "@/utils/googleMapsLink";
import toast from "react-hot-toast";
import DetailBadge from "@/components/ui/DetailBadge";
import useOrderVideoParams from "@/hooks/useOrderVideoParams";
import { useConfirmProductShippingAddressMutation } from "@/redux/feature/orderManagement/productShipping/productShippingApi";
import {
  INDIAN_STATES,
  MAJOR_CITIES,
  MAJOR_CITIES_BY_COUNTRY,
  MAJOR_CITIES_BY_STATE,
  STATES_BY_COUNTRY,
} from "@/constant";
const ProductShipping = ({
  scriptData,
  ActionsRequired,
  isActorAssigned,
}: ProductShippingProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { productShippingData, isDataLoading } = useProductShipping(isOpen);
  console.log(productShippingData);
  const [showConfirmLocationModal, setShowConfirmLocationModal] =
    useState(false);
  const [showAddNewLocationForm, setShowAddNewLocationForm] = useState(false);
  const [showLocationDetails, setShowLocationDetails] = useState(false);
  const [selectedLocation, setSelectedLocation] =
    useState<null | TCreatorShippingData>(null);
  const [selectedLocationId, setSelectedLocationId] = useState("");

  const {
    is_creator_buying: isCreatorBuyingTheProduct,
    issue_status,
    product_detail,
    purchase_invoice,
    shipping_invoice,
    expected_delivery_date,
  } = productShippingData || {};

  const isShipping_started =
    productShippingData?.shipping_status?.isShipping_started;
  const isCreatorReceived = productShippingData?.shipping_status?.is_received;
  const isDelayed = productShippingData?.shipping_status?.is_Delayed;
  const isLocationConfirmed =
    productShippingData?.shipping_status?.is_location_confirmed;
  const isApprovalPendingOrApproved =
    productShippingData?.admin_approval_status?.isApproved ||
    productShippingData?.admin_approval_status?.isPending;

  const isHighValueProduct = (product_detail?.[0]?.cost as number) > 10000;
  const yetToBeShipped = !isShipping_started && !isCreatorBuyingTheProduct;
  const needToBuy = isCreatorBuyingTheProduct;
  const creatorWaitingToReceive =
    isCreatorBuyingTheProduct && isShipping_started;
  const isOthersReasonArise = issue_status?.reason === "others";

  const getShippingStatus = (): ShippingStatus => {
    if (isCreatorReceived) return "SHIPPED";
    if (!isActorAssigned) return "NOT_INITIATED_YET";
    if (isShipping_started) return "SHIPPING_STARTED";
    if (yetToBeShipped) return "PENDING_SHIPMENT";
    if (needToBuy) return "NEED_PURCHASE";
    return "SHIPPED";
  };

  const shippingStatus = getShippingStatus();
  console.log(shippingStatus);
  const getTimelineText = (status: ShippingStatus): string => {
    switch (status) {
      case "NOT_INITIATED_YET":
        return "Not Initiated Yet";
      case "PENDING_SHIPMENT":
        return "Product yet to be shipped by client";
      case "CREATOR_WAITING":
        return "Creator is yet to receive the product";
      case "SHIPPING_STARTED":
        return "Product is on the way";
      case "NEED_PURCHASE":
      case "SHIPPED":
        return "Product is in Creator's Hand";
    }
  };

  const isShippingDetailsUpdated = productShippingData?.creator_shipping_details
    ? true
    : false;

  const renderContent = (status: ShippingStatus) => {
    switch (status) {
      case "PENDING_SHIPMENT":
        return (
          <PendingShipment
            status={isShippingDetailsUpdated}
            onClick={() => setShowConfirmLocationModal(true)}
          />
        );
      case "SHIPPING_STARTED":
        return (
          <ShippingProductView
            isDelayed={isDelayed as boolean}
            isDamagedByCreator={issue_status?.reason === "mistake_damage"}
            damagedWhileShipping={issue_status?.reason === "shipping_damage"}
            delayedDate={issue_status?.delayed_delivery_date as string}
            isHighValueProduct={isHighValueProduct}
            expected_delivery_date={expected_delivery_date as Date}
            isCreatorBuyingProduct={isCreatorBuyingTheProduct as boolean}
            invoice={
              isCreatorBuyingTheProduct
                ? (purchase_invoice as FileDetails)
                : (shipping_invoice as FileDetails)
            }
            isOthersReasonArise={isOthersReasonArise}
            issueDetails={issue_status?.details as string}
            purchase_invoice={purchase_invoice as FileDetails}
          />
        );
      case "NEED_PURCHASE":
        return (
          <ProductPurchaseView
            isCreatorBuyingtheProduct={isCreatorBuyingTheProduct as boolean}
          />
        );
      case "CREATOR_WAITING":
        return <CreatorWaitingView />;
      case "SHIPPED":
        return (
          <ShippedProductView
            productShippingData={productShippingData as TProductShipping}
          />
        );
    }
  };

  const actionRequired = isActionRequired(
    productShippingData as TProductShipping,
  );

  console.log(productShippingData?.admin_approval_status);
  console.log(
    isOpen &&
      !isDataLoading &&
      !isLocationConfirmed &&
      !isApprovalPendingOrApproved,
  );
  useEffect(() => {
    if (
      isOpen &&
      !isDataLoading &&
      !isLocationConfirmed &&
      !isApprovalPendingOrApproved
    ) {
      setShowConfirmLocationModal(true);
    }
  }, [isOpen, isLocationConfirmed, isDataLoading]);

  return (
    <NestedAccordion
      isApproved={isCreatorReceived}
      inProgress={!isCreatorReceived}
      title="Product shipping"
      isOpen={isOpen}
      actionRequired={actionRequired}
      setIsOpen={setIsOpen}
      status={getTimelineText(shippingStatus)}
      timeLine=""
      showTimeLine={false}
      initiated={true}
      isPulse={true}
      initiallyOpen={isOpen}
    >
      {renderContent(shippingStatus)}
      {/* Modal for location confirmation */}

      <Modal
        width="571px"
        padding="0px"
        setOpen={setShowConfirmLocationModal}
        isOpen={showConfirmLocationModal}
      >
        <ConfirmLocationModal
          onClose={() => setShowConfirmLocationModal(false)}
          selectedLocationId={selectedLocationId}
          setSelectedLocationId={setSelectedLocationId}
          onShowDetails={(data) => {
            setSelectedLocation(data);
            setShowLocationDetails(true);
          }}
          onAddNew={() => setShowAddNewLocationForm(true)}
        />
      </Modal>
      <Modal
        width="571px"
        padding="0px"
        setOpen={setShowAddNewLocationForm}
        isOpen={showAddNewLocationForm}
      >
        <AddNewLocation onClose={() => setShowAddNewLocationForm(false)} />
      </Modal>
      {selectedLocation && (
        <Modal
          width="571px"
          setOpen={setShowLocationDetails}
          isOpen={showLocationDetails}
        >
          <ShippingDetailsModal shippingData={selectedLocation} />
        </Modal>
      )}
    </NestedAccordion>
  );
};

export default ProductShipping;
export type TCreatorShippingData = {
  _id: string;
  location_name: string;
  creator_id?: string;
  email: string;
  city: string;
  pin_code: string;
  state: string;
  address: string;
  g_map_link: string;
  number: string;
  desc: string;
};

const ConfirmLocationModal = ({
  onAddNew,
  onShowDetails,
  onClose,
  setSelectedLocationId,
  selectedLocationId,
}: {
  selectedLocationId: string;
  setSelectedLocationId: React.Dispatch<React.SetStateAction<string>>;
  onShowDetails: (data: TCreatorShippingData) => void;
  onAddNew: () => void;
  onClose: () => void;
}) => {
  const [confirmLocation, { isLoading }] =
    useConfirmProductShippingAddressMutation();
  const { userData } = useGlobalContext();

  // get locatioin
  const { data } = useGetShippingAddressesQuery(
    encodeURIComponent(userData?.email),
  );
  // console.log(data);
  //
  const locations: TCreatorShippingData[] = data?.data;

  const handleSelect = (id: string) => {
    if (id === selectedLocationId) {
      setSelectedLocationId("");
    } else {
      setSelectedLocationId(id);
    }
  };

  const { orderId, videoId } = useOrderVideoParams();
  const handleConfirmLocation = async () => {
    const payload = {
      orderId,
      videoId,
      shippingId: selectedLocationId,
    };
    await handleApiRequest({
      payload: payload,
      requestFunction: confirmLocation,
      onSuccess: (res) => {
        console.log(res);
        onClose();
        toast.success("Confirmed");
      },
      onError: (err) => {
        toast.error("Something went wrong");
        console.log(err);
      },
    });
  };

  return (
    <div className="p-6">
      <div className="flex gap-x-4  items-center">
        <LocationConfirmIcon />
        <p className="text-[20px] font-semibold">
          Confirm Your Shipping Address
        </p>
      </div>
      <p className="text-[14px] leading-[140%] text-[#475467] py-6">
        Please confirm the address below is correct. This is where clients will
        ship products for your projects.
      </p>
      <div className="space-y-2">
        <p className="text-[#475467] text-xs font-medium">Selected Location</p>
        {/* Saved Locations */}
        {locations?.map((item, i) => (
          <button
            key={i}
            onClick={() => handleSelect(item?._id)}
            className={`flex  px-[14px] py-[8px] gap-x-1 justify-center rounded-[8px]  text-[14px] items-center border ${
              selectedLocationId === item._id
                ? "border-[#17457D]"
                : " border-[#D0D5DD]"
            } `}
          >
            <p>{item?.location_name}</p>{" "}
            <span
              onClick={() => onShowDetails(item)}
              className="text-[#6941C6] cursor-pointer text-xs"
            >
              (View Location)
            </span>
          </button>
        ))}

        {/* Add new location button */}
        <button
          onClick={onAddNew}
          className="flex gap-2  font-medium  px-[14px] py-[8px] rounded-[8px] text-[#5C5C5C] text-[14px] items-center border border-dashed border-[#D0D5DD]"
        >
          <Plus size={20} color="#D0D5DD" />
          <p>Add New Location</p>
        </button>
      </div>
      <div className="flex flex-col md:flex-row w-full gap-4 my-6">
        <CustomButton
          onClick={() => onClose()}
          variant="outline"
          color="#344054"
          fontSize="14px"
          fontWeight="500"
          padding="10px 24px"
          border="1px solid #E8EBEE"
          borderRadius="8px"
          className="leading-5 w-full"
        >
          Cancel
        </CustomButton>
        <CustomButton
          fontSize="14px"
          onClick={handleConfirmLocation}
          fontWeight="500"
          disabled={!selectedLocationId || isLoading}
          padding="10px 24px"
          backgroundColor="#17457D"
          borderRadius="8px"
          className="leading-5 w-full"
        >
          {isLoading ? "Loading" : "Confirm"}
        </CustomButton>
      </div>
      <div className="flex gap-x-2 items-center bg-[#FAFAFA] rounded-full px-[8px] py-[2px] ">
        <Info size={28} />
        <p className="text-sm text-[#3E3E3E] font-medium">
          Please note: This address cannot be changed later, so please
          double-check for accuracy before confirming.
        </p>
      </div>
    </div>
  );
};

const locationSchema = z.object({
  location_name: z.string().min(1, "Location name is required"),
  pin_code: z
    .string()
    .min(4, "Pincode must be at least 4 digits")
    .max(10, "Pincode too long"),
  state: z.string().min(1, "Please select a state"),
  city: z.string().min(1, "Please select a city"),
  address: z.string().min(1, "Detailed address is required"),
  number: z.string().min(1, "Detailed address is required"),
  mapLink: z.string().superRefine((val, ctx) => {
    if (!val?.trim()) return;
    try {
      normalizeGoogleMapsLink(val);
    } catch (e) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: e instanceof Error ? e.message : "Invalid map URL",
      });
    }
  }),
  description: z.string().optional(),
});
type LocationFormValues = {
  location_name: string;
  pin_code: string;
  state: string;
  city: string;
  address: string;
  number: string;
  mapLink: string;
  description?: string;
};
export const AddNewLocation = ({ onClose }: { onClose: () => void }) => {
  const { userData } = useGlobalContext();
  const methods = useForm<LocationFormValues>({
    resolver: zodResolver(locationSchema),
    defaultValues: {
      location_name: "",
      pin_code: "",
      state: "",
      city: "",
      address: "",
      mapLink: "",
      number: "",
      description: "",
    },
  });

  const {
    handleSubmit,
    // formState: { isSubmitting ,errors},
    reset,
    control,
    register,
    formState: { errors },
    setValue, // Extracted setValue
    watch, // Extracted watch
    trigger,
  } = methods;
  const [addAddress, { isLoading }] = useUploadShippingAddressesMutation();
  useEffect(() => {
    const addr = userData?.address;
    if (!addr) return;

    // Prefill only if form fields are empty (so we don’t overwrite user typing)
    const current = methods.getValues();

    if (!current.state && addr.state) setValue("state", addr.state);
    if (!current.city && addr.city) setValue("city", addr.city);

    // userData.zipCode is actually address text in your example
    if (!current.address && addr.zipCode) setValue("address", addr.zipCode);

    if (!current.mapLink?.trim() && addr.mapLink?.trim()) {
      setValue("mapLink", addr.mapLink.trim());
    }

    // If you *also* have a real pincode somewhere, map it here.
    // if (!current.pin_code && addr.postalCode) setValue("pin_code", addr.postalCode);

    // After setting state, your city options depend on it — trigger validation/update
    trigger(["state", "city", "address", "mapLink"]);
  }, [userData?.address, setValue, trigger]);
  const onSubmit = async (data: LocationFormValues) => {
    const g_map_link = data.mapLink.trim()
      ? normalizeGoogleMapsLink(data.mapLink)
      : "";
    const desc = (data.description ?? "").trim();

    const payload = {
      location_name: data.location_name,
      pin_code: data.pin_code,
      state: data.state,
      city: data.city,
      address: data.address,
      number: data.number,
      g_map_link,
      desc,
      email: userData.email,
      creator_id: userData.creator_id,
    };

    await handleApiRequest({
      payload: payload,
      requestFunction: addAddress,
      onSuccess: (res) => {
        console.log(res);
        toast.success("Location Added");
        onClose();
      },
      onError: (err) => {
        console.log(err);
        toast.error("Something went wrong");
      },
    });
  };

  const selectedState = watch("state");

  const stateOptionsByCountry =
    STATES_BY_COUNTRY[userData?.address?.country as string] || INDIAN_STATES;
  const cityOptionsByCountry =
    MAJOR_CITIES_BY_STATE[userData?.address?.country as string]?.[
      selectedState
    ] ||
    MAJOR_CITIES_BY_COUNTRY[userData?.address?.country as string] ||
    MAJOR_CITIES;

  // get state options
  // get city options
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-6">
        <div className="flex gap-x-4 items-center">
          <LocationConfirmIcon />
          <p className="text-[20px] font-semibold">Add a new Location</p>
        </div>

        <HookFormInputField
          name="location_name"
          label="Location Name"
          placeholder="e.g., Studio A, Central Park"
        />

        <HookFormInputField
          name="pin_code"
          label="Pincode"
          placeholder="e.g- 800001"
        />

        <SelectItemWithHookForm
          label="Select State"
          name="state"
          errors={errors}
          options={stateOptionsByCountry}
          register={register}
          setValue={setValue}
          showOtherInput={true}
          watch={watch}
          required={true}
          placeholder="Select..."
        />
        <SelectItemWithHookForm
          label="Select City"
          name="city"
          errors={errors}
          showOtherInput={true}
          options={cityOptionsByCountry || []}
          register={register}
          setValue={setValue}
          watch={watch}
          required={true}
          placeholder="Select..."
        />

        <HookFormInputField
          name="address"
          label="Detailed Address"
          placeholder="123 Main St, Anytown"
        />
        <HookFormInputField
          name="number"
          label="Phone number"
          placeholder="9999999999"
        />

        <HookFormInputField
          name="mapLink"
          label="Google Map Link (optional)"
          placeholder="https://maps.app.goo.gl/…"
        />

        <HookFormInputField
          name="description"
          label="Description (Optional)"
          placeholder="e.g., Natural light studio with high ceilings..."
        />

        <div className="flex flex-col md:flex-row w-full gap-4 pt-2">
          <CustomButton
            type="button"
            variant="outline"
            color="#344054"
            fontSize="14px"
            fontWeight="500"
            padding="10px 24px"
            border="1px solid #E8EBEE"
            borderRadius="8px"
            className="leading-5 w-full"
            onClick={() => {
              onClose();
              methods.reset();
            }}
          >
            Cancel
          </CustomButton>
          <CustomButton
            type="submit"
            fontSize="14px"
            fontWeight="500"
            disabled={isLoading}
            padding="10px 24px"
            backgroundColor="#17457D"
            borderRadius="8px"
            className="leading-5 w-full"
          >
            {isLoading ? "Saving..." : "Save"}
          </CustomButton>
        </div>
      </form>
    </FormProvider>
  );
};

const ShippingDetailsModal = ({
  shippingData,
}: {
  shippingData: TCreatorShippingData;
}) => {
  return (
    <div className="space-y-[11px] ">
      <h2 className="text-[20px] font-semibold leading-[28px]">
        Shipping Details
      </h2>

      <div className="border-b border-[#E5E9EB] pb-[11px]">
        <DetailBadge title=" Name" desc={shippingData?.location_name} />
      </div>
      <div className="border-b border-[#E5E9EB] pb-[11px]">
        <DetailBadge title=" State" desc={shippingData?.state} />
      </div>
      <div className="border-b border-[#E5E9EB] pb-[11px]">
        <DetailBadge title=" City" desc={shippingData?.city} />
      </div>
      {shippingData?.pin_code && (
        <div className="border-b border-[#E5E9EB] pb-[11px]">
          <DetailBadge title=" Pincode" desc={shippingData?.pin_code} />
        </div>
      )}

      <div className="border-b border-[#E5E9EB] pb-[11px]">
        <DetailBadge title=" Address" desc={shippingData?.address} />
      </div>
      <div className="border-b border-[#E5E9EB] pb-[11px]">
        <DetailBadge title=" Contact Number" desc={shippingData?.number} />
      </div>
      {shippingData?.g_map_link ? (
        <div className="border-b border-[#E5E9EB] pb-[11px]">
          <h3 className="font-medium text-[#98A2B3] text-[14px]">Map link</h3>
          <a
            href={shippingData.g_map_link}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-[#6941C6] text-[16px] underline"
          >
            Open in Google Maps
          </a>
        </div>
      ) : null}
    </div>
  );
};
